// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 167 ? "alertmodal" : chunkId) + "." + {"167":"72865e41","787":"83a6b874"}[chunkId] + ".chunk.js";
};